import React, { Component, Fragment } from 'react';
import OwlCarousel from 'react-owl-carousel'; 
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';

class AllSlide extends Component {
    constructor(props) {
        super(props);
        this.state = {           
            sliderResponsive:{
                0: {
                    items: 2,
                },
                450: {
                    items: 3,
                },
                600: {
                    items: 4,
                },
                1000: {
                    items: 4,
                },
                1200: {
                    items: 5,
                },
                1400: {
                    items: 6,
                },
                1600: {
                    items: 7,
                },

            } 
        }

    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.renderSlider;
    }
    
    render() {

        const options = {
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
        };

        let OnChangeBigSlider = this.props.clickSlider;

        let nextText = '<span style="color:'+localStorage.commentHeaderTextColor+';background:'+localStorage.commentHeaderBgColor+';" aria-label="Next">›</span>';

        let prevText = '<span style="color:'+localStorage.commentHeaderTextColor+';background:'+localStorage.commentHeaderBgColor+';" aria-label="Prev">‹</span>';

        return (
            <Fragment>

            {this.props.allSlide.length > 0 &&

                <div>
                
                    {localStorage.programSliderStatus === '1'
                    ? 
                        <OwlCarousel
                            className="owl-theme allSlideBlock "
                            margin={10}
                            nav
                            responsive={this.state.sliderResponsive}
                            items={7}
                            navText={[prevText,nextText]}
                        >
                        {this.props.allSlide.map((allSlide, index) => {
                            
                            let second = (allSlide.second*1) + (allSlide.hour * 60 * 60) + (allSlide.minute * 60);

                            second =  'checkSlideMatchTime'+second;
                            
                            return (
                                <div className="item" key={index}>
                                    <img onClick={OnChangeBigSlider} hour={allSlide.hour} minute={allSlide.minute} second={allSlide.second} src={`data:image/png;base64,${allSlide.image_url}`} id={second} className={"img-fluid mx-auto d-block"} alt={allSlide.name}></img>
                                </div>
                            )}) }
                        </OwlCarousel>
                    :
                        <OwlCarousel
                            className="owl-theme allSlideBlock"
                            margin={5}
                            nav
                            items={1}
                            navText={[prevText,nextText]}
                        >
                            <div className="item text-center"> <p className="sliderUpcomming">{localStorage.programsliderUpcommingText}</p></div>
                        
                        </OwlCarousel>
                    }

                </div>
            }
            </Fragment>
        );
    }
}

export default AllSlide;